import React from "react";

import SidebarTemplate from "components/templates/SidebarTemplate";
import AttendanceError from "./AttendanceError";

const AttendanceErrorPage: React.FC = () => (
  <SidebarTemplate>
    <AttendanceError />
  </SidebarTemplate>
);

export default AttendanceErrorPage;
